(function(){
    'use strict';

    angular.module('app').controller('EditAddressModalController', EditAddressModalController);

    EditAddressModalController.$inject = [
        'addressData',
        'addressType',
        '$uibModalInstance'
    ];

    function EditAddressModalController(
        addressData,
        addressType,
        $uibModalInstance
    ){
        let vm = this;
        vm.closeModal = closeModal;
        vm.saveData = saveData;
        
        init();
        function init(){
            vm.addressType = angular.copy(addressType);
            vm.addressData = angular.copy(addressData);
        }

        function closeModal(){
            $uibModalInstance.dismiss();
        }

        function saveData(){
            if(!vm.addressDetailsForm.$invalid) {
                addressData = vm.addressData;
                $uibModalInstance.close(addressData);
            }
        }
    }
})();


// WEBPACK FOOTER //
// ./js/controllers/jobs/EditAddressModalController.js